import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import UniversalTemplatesData from "@components/blocks/ContentD2/data/templates/shopiko/UniversalTemplatesData";
import RecomendedTemplatesData from "@components/blocks/ContentD2/data/templates/shopiko/RecomendedTemplatesData";
import NewTemplatesData from "@components/blocks/ContentD2/data/templates/shopiko/NewTemplatesData";
import ModernTemplatesData from "@components/blocks/ContentD2/data/templates/shopiko/ModernTemplatesData";
import ClassicTemplatesData from "@components/blocks/ContentD2/data/templates/shopiko/ClassicTemplatesData";

const BG = {
	modalTitle: 'Дизайн теми',
	templateCategories: [
		{
			name: 'Универсални',
			templates: UniversalTemplatesData
		},
		{
			name: 'Препоръчани',
			templates: RecomendedTemplatesData
		},
		{
			name: 'Нови',
			templates: NewTemplatesData
		},
		{
			name: 'Модерни',
			templates: ModernTemplatesData
		},
		{
			name: 'Класически',
			templates: ClassicTemplatesData
		}
	]
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	modalTitle: 'Design Templates',
	templateCategories: [
		{
			name: 'Universal',
			templates: UniversalTemplatesData
		},
		{
			name: 'Recommended',
			templates: RecomendedTemplatesData
		},
		{
			name: 'New',
			templates: NewTemplatesData
		},
		{
			name: 'Modern',
			templates: ModernTemplatesData
		},
		{
			name: 'Classic',
			templates: ClassicTemplatesData
		}
	]
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];
